export default __webpack_public_path__ + "static/media/yellow_pawn.2fde4384.png";